var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeshfiyProtect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 93,
    viewBox: "0 0 91 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10741_14243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38.3311C1.07059 29.8194 44.9084 23.9355 75.1102 28.6769C86.2105 30.4478 90.831 42.2156 91 42.5583V55.183C91.0075 55.2133 91.0028 55.2454 90.9869 55.2722C90.9711 55.299 90.9454 55.3183 90.9155 55.3258C90.8856 55.3334 90.854 55.3287 90.8276 55.3126C90.8011 55.2965 90.7821 55.2705 90.7746 55.2402C89.704 52.8409 84.9146 43.4724 75.1102 41.93C45.8663 37.3028 3.77523 42.6726 0.225384 50.7844C0.169037 50.8986 0 50.8986 0 50.7273V38.3311Z",
    fill: "url(#paint0_linear_10741_14243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7313 13.7101C83.7313 13.4071 83.6125 13.1165 83.4012 12.9022C83.1899 12.6879 82.9032 12.5676 82.6043 12.5676H76.3498L83.7313 20.051V13.7101Z",
    fill: "url(#paint1_linear_10741_14243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7139 10.9681L62.6012 79.5756V79.6898L82.9424 60.153C83.1875 59.9169 83.3835 59.6336 83.5189 59.3197C83.6544 59.0058 83.7266 58.6676 83.7313 58.3249V20.051L76.3498 12.5676H75.6737C71.1096 12.5676 66.6018 13.1388 62.7139 10.9681Z",
    fill: "url(#paint2_linear_10741_14243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5015 6.05528L47.7257 0.685503C47.0559 0.240685 46.2726 0.00374031 45.4718 0.00374031C44.6711 0.00374031 43.8878 0.240685 43.218 0.685503L28.6241 10.5682C24.5672 13.2531 19.8341 12.5676 14.9882 12.5676H11.6638L11.5511 50.3274L55.5015 6.05528Z",
    fill: "url(#paint3_linear_10741_14243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6012 79.6898V79.5756L62.7139 10.9681L61.9251 10.4539L55.5016 6.05528L11.5511 50.3274L51.2192 90.6579L62.6012 79.6898Z",
    fill: "url(#paint4_linear_10741_14243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26873 54.8403V58.3249C7.27341 58.6676 7.34561 59.0058 7.48108 59.3197C7.61655 59.6336 7.81256 59.9169 8.05758 60.153L39.7808 90.6579C41.3216 92.149 43.3699 92.981 45.5 92.981C47.6301 92.981 49.6784 92.149 51.2192 90.6579L11.5511 50.3274L7.26873 54.8403Z",
    fill: "url(#paint5_linear_10741_14243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6638 12.5676H8.33932C8.05031 12.5822 7.77795 12.7091 7.57865 12.9217C7.37934 13.1344 7.26837 13.4167 7.26873 13.7101V45.3004L11.5511 50.3274L11.6638 12.5676Z",
    fill: "url(#paint6_linear_10741_14243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 55.4115C85.9288 62.1523 79.2235 52.1554 65.5313 46.6714C51.839 41.1873 46.7678 53.4693 32.4557 60.2101C18.1437 66.9509 0 51.1843 0 51.1843V38.2739C0 38.2739 18.1437 54.0977 32.4557 47.2998C46.7678 40.5018 51.839 28.277 65.5313 33.7611C79.2235 39.2451 85.9288 49.242 91 42.5012V55.4115Z",
    fill: "url(#paint7_linear_10741_14243)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10741_14243",
    x1: -0.0225387,
    y1: 41.1359,
    x2: 90.9887,
    y2: 41.1359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#807F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10741_14243",
    x1: 62.7654,
    y1: 16.2133,
    x2: 113.782,
    y2: 16.3012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#005AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10741_14243",
    x1: 9134,
    y1: 19599.3,
    x2: 11047.1,
    y2: 19602.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0078EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10741_14243",
    x1: 11.6718,
    y1: 25.0688,
    x2: 62.75,
    y2: 25.1567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4298F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#53A0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5EA7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#65AAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#67ABF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10741_14243",
    x1: 17383.6,
    y1: 24577.6,
    x2: 22021.5,
    y2: 24585.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10741_14243",
    x1: -51.2573,
    y1: 71.4632,
    x2: 62.67,
    y2: 71.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4B9CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#5FA7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67ABF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10741_14243",
    x1: 1014.65,
    y1: 9864.59,
    x2: 1482.55,
    y2: 9865.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10741_14243",
    x1: 18.5155,
    y1: 19.4969,
    x2: 73.2536,
    y2: 73.4889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10741_14243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 93,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeshfiyProtect);
export default __webpack_public_path__ + "static/media/meshfiy_protect.c6b575d9711fe94cdab205aff672dca9.svg";
export { ForwardRef as ReactComponent };